import { Box, Grid, LinearProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { search as searchArtifact } from 'store/evaluation/admin-artifact';
import { search as searchGoals } from 'store/evaluation/admin-goal';
import { search as searchSelfEvaluation } from 'store/evaluation/admin-eval-rating';
import { search as searchEvaluationDetails, getReport } from 'store/evaluation/admin-eval-self';
import { useEffect } from "react";
import EvaluationArtifact from "./EvaluationArtifact";
import EvaluationGoals from "./EvaluationGoals";
import EvaluationSelf from "./EvaluationSelf";
import EvaluationDetails from "./EvaluationDetails";

export default function EvaluationDashboard() {
    const artifactList = useSelector(state => state.adminEvaluation.artifact.list)
    const goalsList = useSelector(state => state.adminEvaluation.goal.list)
    const selfEvaluationList = useSelector(state => state.adminEvaluation.selfEvaluation.list)
    const evaluationDetail = useSelector(state => state.adminEvaluation.evaluationDetails.list)
    const evaluationReport = useSelector(state => state.adminEvaluation.evaluationDetails.reportList)
    const dispatch = useDispatch()

    useEffect(() => {
      artifactList || dispatch(searchArtifact());
    }, [dispatch, artifactList]);

    useEffect(() => {
      goalsList || dispatch(searchGoals());
    }, [dispatch, goalsList]);

    useEffect(() => {
      selfEvaluationList || dispatch(searchSelfEvaluation());
    }, [dispatch, selfEvaluationList]);

    useEffect(() => {
      evaluationDetail || dispatch(searchEvaluationDetails());
    }, [dispatch, evaluationDetail]);

    useEffect(() => {
      evaluationReport || dispatch(getReport());
    }, [dispatch, evaluationReport]);

    if (!evaluationDetail || evaluationDetail.length === 0) {
      return <LinearProgress width="100%" />;
    }

  return (
    <Box>
      {/* Row 1 */}
      <Grid container spacing={1} mb={1} alignItems="stretch">
        <Grid item xs={12} display="flex">
          <EvaluationDetails evaluationDetail={evaluationDetail} evaluationReport={evaluationReport} />
        </Grid>
      </Grid>

      {/* Row 2 */}
      <Grid container spacing={1} mb={1}>
        <Grid item xs={12}>
          <EvaluationArtifact artifactList={artifactList} />
        </Grid>
      </Grid>

      {/* Row 3 */}
      <Grid container spacing={1} mb={1} alignItems="stretch">
        <Grid item xs={12} md={6} display="flex">
          <EvaluationSelf selfEvaluationList={selfEvaluationList} />
        </Grid>

        <Grid item xs={12} md={6} display="flex">
          <EvaluationGoals goalsList={goalsList} />
        </Grid>
      </Grid>
    </Box>
  );
}
